import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({ template: '', standalone: false })
export abstract class ChoiceInputComponent<T> {
  @Input()
  public bold = true;

  @Input()
  public name: string;

  @Input()
  public values: T[];

  @Input()
  public control: FormControl;

  @Input()
  public display: (value: T) => string = (value) => value.toString();

  @Input()
  public value: (value: T) => string = (value) => value.toString();

}
